import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import './css/App.css';
import './css/mobile-320.css';
import './css/mobile-480.css';
import './css/tablet-768.css';
import './css/home.css';
import './css/responsive-overrides.css';
import './css/pages/exchange/exchange-modern.css';
import './css/pages/withdraw/withdraw-modern.css';
import './css/pages/deposit/deposit-modern.css';
import './css/pages/transactions/transactions-modern.css';
import './css/layout/mobile-bottom-navigation.css';
import './css/base/typography-system.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
